import { all, call, fork, put, select, take } from 'redux-saga/effects';

import { ProductSortField, QueryProductSearchArgs, SortDirection } from 'types/schema';
import { getBrand, getBrands, getProducts } from 'utils/apollo';
import { brandDetail, similarBrands, brandProducts } from './actions';
import { createMatchSelector, push } from 'connected-react-router';
import ActionTypes from './constants';
import { selectBrandInfo } from './selectors';

function* getBrandProducts({ brandId, categoryId }: { brandId?: number; categoryId?: number }) {
  yield put(brandProducts.request());

  const brandInfo = yield select(selectBrandInfo());
  let currentBrandId = brandInfo.id;

  if (brandId) {
    currentBrandId = brandId;
  }

  try {
    const params: QueryProductSearchArgs = {
      sort: [{ field: ProductSortField.Name, order: SortDirection.Asc }],
      filter: {
        brandId: Number(currentBrandId),
        categoryIds: categoryId ? [categoryId] : [],
      },
      pagination: { page: 0, size: 100 },
    };
    const response = yield call(getProducts, params);
    if (!response.errors) {
      yield put(brandProducts.success(response.data));
    }
  } catch (error) {
    yield put(brandProducts.failure(error as Error));
  }
}

function* filterFlow() {
  while (true) {
    const { payload } = yield take(ActionTypes.APPLY_FILTER);
    yield call(getBrandProducts, {
      categoryId: payload.categoryId,
    });
  }
}

function* getSimilarBrands(categories: number[], brandId: string) {
  const response = yield call(getBrands, {
    categoryIds: categories,
    pagination: { page: 0, size: 1000 },
  });

  if (!response.errors) {
    const brands = response?.data?.filter((brand) => brand.id !== brandId);
    yield put(similarBrands.success(brands));
  } else {
    yield put(similarBrands.failure(response.errors));
  }
}

function* initBrandDetails() {
  const lang = window.localStorage.getItem('lang') || 'vi';
  yield put(brandDetail.request());

  const route = yield select(createMatchSelector('/thuong-hieu/:slug'));
  const slugs = route.params.slug;
  const slugsArray=slugs.split('-');
  const id = slugsArray[slugsArray.length-1].slice(1);


  const response = yield call(getBrand, { brandId: Number(id) });

  if (!response.errors) {
    yield put(
      brandDetail.success({
        brandInfo: {
          id: response.id,
          logo: response.imageUrl,
          name: response.name,
          description: lang === 'vi' ? response.description_vi : response.description,
        },
        categories: response.productCategories,
      }),
    );

    yield all([
      call(getBrandProducts, {
        brandId: response.id,
      }),
      call(
        getSimilarBrands,
        response.productCategories.map((category) => category.id),
        id,
      ),
    ]);
  } else {
    yield put(brandDetail.failure(response.errors));
    yield put(push('/not-found'));
  }
}

export default function* saga() {
  yield fork(initBrandDetails);
  yield fork(filterFlow);
}
